import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
const PermissionsContext = createContext();
export const PermissionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState([]);
  const [permittedRoutes, setPermittedRoutes] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true); //true , for redirection to home issue
  const masterDataKeys = [
    'MASTER_DATA_CUSTOMER_CATEGORY',
    'MASTER_DATA_AREA',
    'MASTER_DATA_DISTRICT',
    'MASTER_DATA_LOGISTIC_LINE',
    'MASTER_DATA_DELIVERY_METHOD',
    'MASTER_DATA_PAYMENT_METHOD',
    'MASTER_DATA_ORIGIN',
    'MASTER_DATA_PRODUCT_UNIT',
    'MASTER_DATA_SPECIFICATION_UNIT',
    'MASTER_DATA_PROCESS_LOCATION',
    'MASTER_DATA_ORDER_STATUS',
    'MASTER_DATA_DELIVERY_STATUS',
    'MASTER_DATA_PAYMENT_STATUS',

    'MASTER_DATA_PROCESS_CATEGORY',
  ];
  const reportKeys = [
    'FBZ_ORDER_REPORT_CUSTOMER_SALES_SUMMARY',
    'FBZ_ORDER_REPORT_CUSTOMER_SALES_QUANTITY',
    'FBZ_ORDER_REPORT_PRODUCT_SALES_ANALYSIS',
  ];
  const routeMapping = {
    '/': 'FBZ_ORDER_INFO_HOME_PAGE',
    '/logistics': 'LOGISTIC_DELIVERY_INFO_HOME_PAGE',
    '/lob-products': 'LOB_PRODUCT_INFO_HOME_PAGE',
    '/fbz-products': 'FBZ_PRODUCT_INFO_HOME_PAGE',
    '/master-data': masterDataKeys,
    '/orders-catering': 'CATERING_ORDER_INFO_HOME_PAGE',
    '/fbz-orders': 'FBZ_ORDER_INFO_HOME_PAGE_2',
    '/fbz-picking-list': 'FBZ_ORDER_SUMMARY',
    '/catering-picking-list': 'CATERING_ORDER_SUMMARY',
    '/catering-orders': 'CATERING_ORDER_INFO_HOME_PAGE_2',
    '/fbz-customers': 'FBZ_CUSTOMER_INFO_HOME_PAGE',
    '/fbz-customers-group': 'FBZ_CUSTOMER_GROUP_HOME_PAGE',
    '/catering-customers-group': 'CATERING_CUSTOMER_GROUP_HOME_PAGE',
    '/catering-customers': 'CATERING_CUSTOMER_INFO_HOME_PAGE',
    '/fbz-inventory': 'FBZ_INVENTORY',
    '/fbz-report': reportKeys,
    '/fbz-sales-summary': 'FBZ_ORDER_REPORT_CUSTOMER_SALES_SUMMARY',
    '/fbz-sales-quantity': 'FBZ_ORDER_REPORT_CUSTOMER_SALES_QUANTITY',
    '/fbz-sales-analysis': 'FBZ_ORDER_REPORT_PRODUCT_SALES_ANALYSIS',
    // '/catering-picking-lists': 'ORDER_SUMMARY',
    // "/catering-inventory": "CATERING_INVENTORY",
    '/permissions': 'USER_PERMISSIONS',
  };
  const allRoutes = [
    '/',
    '/logistics',
    '/permissions',
    '/lob-products',
    '/fbz-products',
    '/master-data',
    '/orders-catering',
    '/fbz-orders',
    '/fbz-picking-list',
    '/fbz-inventory',
    '/fbz-report',
    '/fbz-sales-summary',
    '/fbz-sales-quantity',
    '/fbz-sales-analysis',
    '/fbz-customers',
    '/fbz-customers-group',
    '/catering-customers-group',
    '/catering-picking-list',
    '/catering-orders',
    // '/catering-picking-lists',
    '/catering-customers',
    // "/catering-inventory",
    // '/notifications',
    '/setting',
  ];
  const nonProtectedRoutes = [
    // '/notifications',
    '/setting',
    '/login',
  ];

  useEffect(() => {
    if (user?.permissions) {
      setPermissionsLoading(true);
      const permissionsMap = preprocessPermissions(user.permissions);
      setPermissions(permissionsMap);
    }
  }, [user]);
  useEffect(() => {
    if (user?.permissions && Object.keys(permissions).length > 0) {
      setPermissionsLoading(true);
      // const permissionsMap = preprocessPermissions(user.permissions);
      // setPermissions(permissionsMap);

      if (user.role === 'admin') {
        setPermittedRoutes(allRoutes);
      } else {
        const userPermittedRoutes = [...nonProtectedRoutes];
        Object.keys(routeMapping).forEach((route) => {
          const routeKey = routeMapping[route];
          if (Array.isArray(routeKey)) {
            // If it's an array of keys, check if any permission is granted
            if (routeKey.some((key) => canView(key))) {
              userPermittedRoutes.push(route);
            }
          } else {
            // If it's a single permission key, check if the permission is granted
            if (canView(routeKey)) {
              userPermittedRoutes.push(route);
            }
          }
        });

        setPermittedRoutes(userPermittedRoutes);
      }
    }
  }, [permissions]);

  useEffect(() => {
    // Only set loading to false if both permissions and permittedRoutes are ready
    if (permissions && permittedRoutes.length > 0) {
      setPermissionsLoading(false);
    }
  }, [permittedRoutes]);

  const hasPermission = (key, type) => {
    const permission = permissions[key];
    return permission?.[type] === 1; // e.g., , view_permission, edit_permission
  };

  const canView = (key) => hasPermission(key, 'view_permission');
  const canEdit = (key) => hasPermission(key, 'edit_permission');
  // const canAdd = (key) => hasPermission(key, "add_permission");

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        setPermissions,
        hasPermission,
        canView,
        canEdit,
        // canAdd,
        permissionsLoading,
        permittedRoutes,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

const preprocessPermissions = (permissions) =>
  permissions.reduce((map, perm) => {
    map[perm.permission_type.key] = perm;
    return map;
  }, {});

export const usePermissions = () => useContext(PermissionsContext);
